import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'DashboardHeader',
    data () {
        return {
            user: {},
            img_url: service.imageURL,
            site_url: "",
            referral_text: "",
            copy_succ:false,
            site_set_url: "https://share.cityneeds.ng/?ref="
        }
    },
    methods: {
        //settings
        copyLink() {
             this.copy_succ =  true;
            this.$clipboard(this.referral_text)
            //var btn = $('.linky').tooltip({
            //     trigger: 'click',
            //     placement: 'bottom'
            // });
            // this.setTooltip(btn, 'Copied');
            // this.hideTooltip(btn);
            // this.copy_succ =  true;
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            //special case for profile
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.user = data.body.data;
                                }
                                this.referral_text = 
                                `Hey,\nCityneeds is a fast, simple and secure webapp that i go to whenever i need skilled-workers like plumbers, and tilers, etc. It also doubles as a payment platform for real-time settlement of AEDC, Dstv, Remita, MTN, amongst others bills. The sweetest part of it is that I get CASH-BACK REWARD on most payments I make!
                                \nClick to signup now : `+this.site_set_url+this.user.user_referral_code+`\nIt is absolutely free! `;
                            }).catch((err) => {
                                if(err) {
                                    toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            })
                         //../special case for profile
                         }, this);
                    }else {
                       this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },
    },
    created: function(){
        this.preset();
        setTimeout(function (){
            if(localStorage.getItem("cityneeds_prompt") == 0){
                $('#prompt').modal();
                localStorage.setItem("cityneeds_prompt", 1);
            }
            
            //$('#prompt').modal();
        }, 4000);
        
    }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard-Header/script.js